module.exports = __webpack_public_path__ + "img/Logo7636.e0988592.jpg";